var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{staticClass:"mt-1 mb-2",attrs:{"label-class":"pb-1"}},[_c('template',{slot:"label"},[_c('b',{staticClass:"mb-0 pb-0"},[_vm._v("Board: ")])]),_c('vue-single-select',{attrs:{"classes":{
      input: 'form-control mt-0',
      dropdown: 'dropdown p-0',
    },"options":_vm.boards,"option-label":"title"},model:{value:(_vm.board),callback:function ($$v) {_vm.board=$$v},expression:"board"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }